import type { ProductCategory } from "@/types/products/api-types/product-category-types";

export function getProductCategoryFormValues(category?: ProductCategory) {
  return {
    name: category?.name ?? "",
  };
}
